import { Popover } from '@mantine/core';
import ArrowRight from 'components/DynamicIcon/ArrowRight';
import PropTypes from 'prop-types';
import React from 'react';
import { ProgressBar, Step } from 'react-step-progress-bar';
import { format_curency } from 'utils';

import { configPoint } from 'components/Organisms/LoyaltyStore/ScoreLevel/data';
import { RankCodeServer } from 'constants/index';

import { checkIndexShowToolTip } from 'helpers/loyaltyStore';
import 'react-step-progress-bar/styles.css';

const ScoreLine = ({ listRank, assetData, simpleMode = false }) => {
  const {
    maxScore = configPoint.diamond,
    rankCode = RankCodeServer.MEMBER,
    pointToNextTempRank = 300000000,
    nextRankName,
    lineColor,
    point = 0,
  } = assetData;

  const percent = ((point <= maxScore ? point : maxScore) / maxScore) * 100;

  const indexTooltipNeedShow = checkIndexShowToolTip(rankCode);

  let textShow = '';

  if (indexTooltipNeedShow >= 3 && pointToNextTempRank === 0) {
    textShow = 'Điều khoản chương trình BaoViet Loyalty';
  } else {
    textShow = `Cần tích lũy thêm ${format_curency(pointToNextTempRank
    )} điểm để trở thành ${nextRankName}`;
  }

  const getPercent = (max, now) => {
    const result = (now / max) * 100;
    return result;
  };

  return (
    <>
      {!simpleMode && (
        <div className='w-full px-8 lg:px-0 cursor-pointer'>
          <ProgressBar
            height={3}
            stepPositions={listRank.map((rank) => getPercent(maxScore, rank.mount))}
            filledBackground={lineColor}
            percent={percent}
          >
            {listRank.map((checkpoint, indexlistRank) => {
              const lengthList = listRank.length;
              let nodeReturn = <></>;
              let showToolTip = false;

              if (indexlistRank === indexTooltipNeedShow) {
                showToolTip = true;
              }
              return (
                <Step key={indexlistRank}>
                  {({ accomplished, index }) => {
                    if (!showToolTip) {
                      nodeReturn = (
                        <div className={`transitionStep ${accomplished ? 'accomplished' : null}`}>
                          {checkpoint.node}
                        </div>
                      );
                    } else {
                      nodeReturn = (
                        <Popover
                          position={
                            indexlistRank === 0 || indexlistRank === 1
                              ? 'top-start'
                              : indexlistRank === lengthList - 1
                              ? 'top-end'
                              : 'top'
                          }
                          middlewares={{ shift: true, flip: false }}
                          withArrow
                          opened
                          arrowSize={12}
                          offset={-12}
                          styles={{
                            dropdown: {
                              padding: '10px',
                              paddingTop: '5px',
                              paddingBottom: '5px',
                              paddingRight: '0',
                              borderRadius: 0,
                              border: '1px solid black',
                              minWidth: '360px !important',
                              width: '100%',
                            },
                            arrow: {
                              bottom: '-6px',
                              border: '1px solid black',
                            },
                          }}
                        >
                          <Popover.Target>
                            <div
                              className={`transitionStep ${accomplished ? 'accomplished' : null}`}
                            >
                              {checkpoint.node}
                            </div>
                          </Popover.Target>
                          <Popover.Dropdown>
                            <div className='grow flex items-center text-[13px] leading-4'>
                              {/*<span className='grow'>{textShow}</span>*/}
                              {(indexTooltipNeedShow >= 3 && pointToNextTempRank === 0) &&
                                <span className='grow'>Điều khoản chương trình BaoViet Loyalty</span>

                              }
                              {(indexTooltipNeedShow < 3 || pointToNextTempRank !== 0) &&
                              <span className='grow'>Cần tích lũy thêm <span className='text-008BD2 font-bold'>{format_curency(pointToNextTempRank)}</span> điểm để trở thành <span className='text-008BD2 font-bold'>{nextRankName}</span></span>

                              }

                              <ArrowRight size={18} fill={'currentColor'} />
                            </div>
                          </Popover.Dropdown>
                        </Popover>
                      );
                    }
                    return nodeReturn;
                  }}
                </Step>
              );
            })}
          </ProgressBar>
        </div>
      )}
      {simpleMode && (
        <div className='my-2 w-full px-6'>
          <ProgressBar height={4} filledBackground={lineColor} percent={percent} />
          {/*<p className='mt-2'>{textShow}</p>*/}
          {(indexTooltipNeedShow >= 3 && pointToNextTempRank === 0) &&
          <p className='mt-2'>Điều khoản chương trình BaoViet Loyalty</p>

          }
          {(indexTooltipNeedShow < 3 || pointToNextTempRank !== 0) &&
          <p className='mt-2'>Cần tích lũy thêm <span className='text-0090F0 font-bold'>{format_curency(pointToNextTempRank)}</span> điểm để trở thành <span className='text-0090F0 font-bold'>{nextRankName}</span></p>

          }
        </div>
      )}
    </>
  );
};

ScoreLine.propTypes = {
  listRank: PropTypes.array.isRequired,
  assetData: PropTypes.object.isRequired,
  simpleMode: PropTypes.bool,
};

export default ScoreLine;
